/* eslint-disable no-shadow */
import * as ActionTypes from 'actions/personalInfos'

const initialState = {
  numRecords: 0,
  selectedStatusFilter: 1,
  selectedCodeFilter: '',
  selectedLocationFilter: '',
  selectedPartner: {},
  isFetching: false,
  isError: false,
  fetched: false,
  personalinfos: [],
  locations: [],
  codes: [],
}

const getLocations = (personalinfos) => {
  const sortedlocation = [...personalinfos].sort((a, b) => ((a.location > b.location) ? 1 : -1))
  const uniquelocation = [...new Set(sortedlocation.map(item => item.location))]
  // const locationoptions = [{ value: '', label: 'Location'}]
  const locationoptions = []
  uniquelocation.map(item =>
    locationoptions.push({ value: `${item}`, label: `${item}` }))
  return locationoptions
}

const getCodes = (personalinfos) => {
  const sortedcode = [...personalinfos].sort((a, b) => ((a.code > b.code) ? 1 : -1))
  const uniquecode = [...new Set(sortedcode.map(item => item.code))]
  // const codeoptions = [{ value: '', label: 'Code'}]
  const codeoptions = []
  uniquecode.map(item =>
    codeoptions.push({ value: `${item}`, label: `${item}` }))
  return codeoptions
}

// Updates error message to notify about the failed fetches.
export default function personalinfos(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.PF_GETTING_PERSONALINFOS:
      return Object.assign({}, state, {
        isFetching: true,
      })
    // eslint-disable-next-line no-case-declarations
    case ActionTypes.PF_RECEIVED_PERSONALINFOS:
      const locations = getLocations(action.personalinfos)
      const codes = getCodes(action.personalinfos)
      return {
        ...state,
        isFetching: false,
        fetched: true,
        personalinfos: action.personalinfos,
        numRecords: Object.keys(action.personalinfos).length,
        locations,
        codes,
      }
    case ActionTypes.PF_GETTING_PERSONALINFOS_ERROR:
      return Object.assign({}, state, {
        isFetching: false,
      })
    case ActionTypes.PF_SET_SELECTEDFILTERSTATUS:
      return {
        ...state,
        selectedStatusFilter: action.selectedFilter,
      }
    case ActionTypes.PF_SET_SELECTEDFILTERCODE:
      return {
        ...state,
        selectedCodeFilter: action.selectedFilter,
      }
    case ActionTypes.PF_SET_SELECTEDFILTERLOCATION:
      return {
        ...state,
        selectedLocationFilter: action.selectedFilter,
      }
    case ActionTypes.PF_SET_SELECTEDPARTNER:
      return {
        ...state,
        selectedPartner: action.selectedPartnerInfo,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/personalInfos.js